module.exports = __webpack_public_path__ + "static/media/The Moutain.494c4805.jpg";